'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SelectComponent = require('../input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _TextInputComponent = require('../input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _SubmitButtonComponent = require('../input/SubmitButtonComponent');

var _SubmitButtonComponent2 = _interopRequireDefault(_SubmitButtonComponent);

var _RecurringPaymentsComponent = require('../input/RecurringPaymentsComponent');

var _RecurringPaymentsComponent2 = _interopRequireDefault(_RecurringPaymentsComponent);

var _commonFunctions = require('../../helpers/commonFunctions');

var _LoadingComponent = require('../../../components/common/LoadingComponent.js');

var _LoadingComponent2 = _interopRequireDefault(_LoadingComponent);

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a box displaying the current application quote estimate,
 * as well as any possible details regarding this estimate.
 * @extends {Component}
 */
var SaveQuoteComponent = function (_React$Component) {
  _inherits(SaveQuoteComponent, _React$Component);

  function SaveQuoteComponent(props) {
    _classCallCheck(this, SaveQuoteComponent);

    var _this = _possibleConstructorReturn(this, (SaveQuoteComponent.__proto__ || Object.getPrototypeOf(SaveQuoteComponent)).call(this, props));

    _this.saveQuote = _this.saveQuote.bind(_this);
    _this.showEmailModal = _this.showEmailModal.bind(_this);
    _this.hideEmailModal = _this.hideEmailModal.bind(_this);
    _this.sendEmailQuote = _this.sendEmailQuote.bind(_this);
    _this.formErrors = _this.formErrors.bind(_this);

    _this.state = {
      showEmailModal: false,
      emailSuccess: false
    };
    return _this;
  }

  _createClass(SaveQuoteComponent, [{
    key: 'showEmailModal',
    value: function showEmailModal() {
      this.props.application.quote.mailStatus = '';
      this.setState({
        showEmailModal: true
      });
    }
  }, {
    key: 'hideEmailModal',
    value: function hideEmailModal() {
      this.setState({
        showEmailModal: false
      });
    }
  }, {
    key: 'areEmailsValid',
    value: function areEmailsValid() {
      var toEmail = this.props.fields.application.quote.email_to.value.trim();
      var ccEmail = this.props.fields.application.quote.email_cc.value.trim();

      if (toEmail === '' || !this.validateEmail(toEmail) || ccEmail !== '' && !this.validateEmail(ccEmail)) {
        return false;
      }

      return true;
    }
  }, {
    key: 'sendEmailQuote',
    value: function sendEmailQuote() {
      this.setState({
        emailSuccess: true
      });

      (0, _commonFunctions.sendSavedQuoteEmail)(this, {
        to: this.props.fields.application.quote.email_to.value.trim(),
        cc: this.props.fields.application.quote.email_cc.value.trim()
      });
    }
  }, {
    key: 'saveQuote',
    value: function saveQuote() {
      (0, _commonFunctions.saveQuoteNum)(this);
      this.props.context.state.showSaveQuote = false;
    }
  }, {
    key: 'formErrors',
    value: function formErrors() {
      return this.props.application.quote.information && Array.isArray(this.props.application.quote.information);
    }
  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      var format = /\S+@\S+\.\S+/;
      return format.test(email);
    }
  }, {
    key: 'hasRecurringPayments',
    value: function hasRecurringPayments() {
      return this.props.recurringPaymentsEnabled && this.props.context.recurringPaymentsAllowed();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.hasRecurringPayments() ? _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'paymentOption',
          inputLabel: (0, _translate.t)('Payment Option'),
          hasExpandableHint: true,
          expandableHintId: 'paymentOptionHint',
          expandableHintTitle: (0, _translate.t)('Payment Option'),
          expandableHintContent: this.props.formConfig.form.steps[0].fields['payment.payment_option'].hint,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.payment.payment_option,
          inputComponentProps: {
            options: [{ value: 'lumpsum', text: (0, _translate.t)('Lump Sum') }, { value: 'monthly', text: (0, _translate.t)('Monthly Installments') }],
            onChangeHook: this.props.context.onChangeHook
          }
        }) : null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: this.state.showEmailModal, className: 'emailModal' },
          this.props.application.quote.mailStatus === 'sent' ? _react2.default.createElement(
            'div',
            { className: 'modal-button div-center' },
            _react2.default.createElement(
              'div',
              null,
              (0, _translate.t)('Your quote has been emailed to the address provided')
            ),
            _react2.default.createElement(
              'div',
              { className: 'buttons' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary button margin-left', onClick: this.hideEmailModal },
                (0, _translate.t)('Close')
              )
            )
          ) : this.props.application.quote.mailStatus === 'failed' ? _react2.default.createElement(
            'div',
            { className: 'modal-button div-center' },
            _react2.default.createElement(
              'div',
              null,
              (0, _translate.t)('The quote you requested was not delivered to the address provided.')
            ),
            _react2.default.createElement(
              'div',
              { className: 'buttons' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary button margin-left', onClick: this.hideEmailModal },
                (0, _translate.t)('Close')
              )
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'modal-button' },
            _react2.default.createElement(_LabelledInputComponent2.default, {
              inputId: 'quoteEmailTo',
              inputLabel: (0, _translate.t)('To Email'),
              inputComponent: _TextInputComponent2.default,
              inputComponentField: this.props.fields.application.quote.email_to,
              inputComponentProps: {
                type: 'text'
              }
            }),
            _react2.default.createElement(_LabelledInputComponent2.default, {
              inputId: 'quoteEmailCc',
              inputLabel: (0, _translate.t)('CC Email') + ' (' + (0, _translate.t)('Optional') + ')',
              inputComponent: _TextInputComponent2.default,
              inputComponentField: this.props.fields.application.quote.email_cc,
              inputComponentProps: {
                type: 'text'
              }
            }),
            _react2.default.createElement(
              'div',
              { className: 'buttons' },
              _react2.default.createElement(
                'button',
                { disabled: !this.areEmailsValid(), className: 'btn btn-primary button margin-left', onClick: this.sendEmailQuote },
                (0, _translate.t)('Send Email')
              ),
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary button margin-left', onClick: this.hideEmailModal },
                (0, _translate.t)('Cancel')
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'ingle-form-quote quote-box' },
          this.props.application.id && this.hasRecurringPayments() && this.props.fields.payment.payment_option.value === 'monthly' ? _react2.default.createElement(_RecurringPaymentsComponent2.default, this.props) : null,
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'h2',
                    { className: 'display-price quote-price-display' },
                    (0, _translate.t)('Your Quote'),
                    ': ',
                    this.props.application.quote.price ? this.props.application.quote.price : this.props.initialQuoteAmount + ' ' + this.props.quoteCurrency
                  )
                )
              )
            )
          ),
          this.props.quoteEnabled && !this.props.showSaveQuote && this.props.application.id && _react2.default.createElement(
            'div',
            { className: 'save-quote-div' },
            _react2.default.createElement(
              'div',
              { className: 'quote-text' },
              (0, _translate.t)('Your quote has been saved.')
            ),
            _react2.default.createElement(
              'div',
              { className: 'quote-text' },
              (0, _translate.t)('Quote Number'),
              ': ',
              this.props.application.quote.reference_id
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _reactBootstrap.Button,
                {
                  bsStyle: 'primary',
                  className: 'ingle-form-submit-button button',
                  onClick: this.showEmailModal
                },
                (0, _translate.t)('Email Quote')
              )
            )
          ),
          !(0, _url2.default)('user_code', null) && this.props.showSaveQuote && this.props.application.id && _react2.default.createElement(
            'div',
            { onClick: this.saveQuote, className: 'quote-text click-quote' },
            (0, _translate.t)('Save Quote')
          )
        ),
        _react2.default.createElement(_LoadingComponent2.default, { show: this.props.application.quote.loading, text: this.state.loadingModalText }),
        _react2.default.createElement(
          'div',
          { className: 'div-center padding-topbottom-20' },
          _react2.default.createElement(
            _SubmitButtonComponent2.default,
            {
              isFormSubmitting: this.props.submitting,
              isFormInvalid: false,
              errors: this.formErrors(),
              showErrors: this.props.showErrors
            },
            (0, _translate.t)('Complete Application')
          )
        )
      );
    }
  }]);

  return SaveQuoteComponent;
}(_react2.default.Component);

SaveQuoteComponent.propTypes = {
  initialQuoteAmount: _react2.default.PropTypes.string,
  quoteAmount: _react2.default.PropTypes.string,
  quoteCurrency: _react2.default.PropTypes.string,
  application: _react2.default.PropTypes.object,
  context: _react2.default.PropTypes.object,
  fields: _react2.default.PropTypes.object,
  quoteEnabled: _react2.default.PropTypes.bool,
  submitting: _react2.default.PropTypes.bool,
  showSaveQuote: _react2.default.PropTypes.bool,
  showEmailModal: _react2.default.PropTypes.bool,
  saveQuote: _react2.default.PropTypes.func,
  recurringPaymentsEnabled: _react2.default.PropTypes.bool,
  recurringPaymentsAllowed: _react2.default.PropTypes.bool,
  onChange: _react2.default.PropTypes.func,
  showErrors: _react2.default.PropTypes.func,
  formConfig: _react2.default.PropTypes.object
};
SaveQuoteComponent.defaultProps = {
  initialQuoteAmount: '$0.00',
  quoteCurrency: ''
};
exports.default = SaveQuoteComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/SaveQuoteComponent.jsx
// module id = 1661
// module chunks = 0